import Vuex from 'vuex'
import Vue from 'vue'
import { util, EventBus } from 'pevueglobal'
import Browserstore from 'store2'
import * as Sentry from '@sentry/browser'
import jwtDecode from 'jwt-decode'
import pathify from './store/pathify'

// Beheer
import Spe010Persoonsgegevens from './store/modules/beheer/Spe010Persoonsgegevens_STORE'

import extOrgDetailsForm from './store/modules/ExtOrgDetailsForm_STORE'
import SPE610ExtOrgSelection from './store/modules/SPE610ExtOrgSelection_STORE'
import SPE620ExtOrgAccountAanvragen from './store/modules/SPE620ExtOrgAccountAanvragen_STORE'
import SPE650BHExtOrgDetails from './store/modules/SPE650BHExtOrgDetails_STORE'
import Spe005PrHelpdesk from './store/modules/Spe005PrHelpdesk_STORE.js'
import Agenda from './store/modules/public/Agenda_STORE.js'
import evalstore from './store/modules/eval_STORE'
import Spe032MemberCard from './store/modules/Spe032MemberCard_STORE'
import Spe015PrPersonAutorisedAdmin from './store/modules/Spe015PrPersonAutorisedAdmin_STORE'
import Spe020PrStatusoverzicht from './store/modules/Spe020PrStatusoverzicht_STORE'
import Spe026PrDetailPE from './store/modules/Spe026PrDetailPE_STORE'
import SPE203Meldingen from './store/modules/SPE203Meldingen_STORE'
import Spe671PrExtOrgMyAdmins from './store/modules/Spe671PrExtOrgMyAdmins_STORE'
import SPE696PatientEnquete from './store/modules/SPE696PatientEnquete_STORE'
import VMSWbestuurdersAandeelhouders from './store/modules/VMSWbestuurdersAandeelhouders_STORE'
import PointsOfInterest from './store/modules/PointsOfInterest_STORE'
import SKFPraktijken from './store/modules/SKFPraktijken_STORE'
import SPE021PEActiviteiten from './store/modules/SPE021PEActiviteiten_STORE'
import VVNpersonHandelingen from './store/modules/VVNpersonHandelingen_STORE'
import SRPOOvereenkomsten from './store/modules/SRPOOvereenkomsten_STORE.js'
import multipage from './pages/tests/multipagetest/multipage_STORE'
import wizard from './store/modules/test/wizard_STORE'
import Metafields from './store/MetaFields'
import translations from './store/translations'
import { router } from './router'
import jquery from 'jquery'
let $ = jquery
Vue.use(Vuex)
const PEStore = new Vuex.Store({
  plugins: [pathify.plugin],
  modules: {
    evalstore,
    Spe005PrHelpdesk,
    Agenda,
    Spe032MemberCard,
    Spe015PrPersonAutorisedAdmin,
    Spe020PrStatusoverzicht,
    Spe026PrDetailPE,
    Spe671PrExtOrgMyAdmins,
    VMSWbestuurdersAandeelhouders,
    PointsOfInterest,
    SKFPraktijken,
    SPE021PEActiviteiten,
    extOrgDetailsForm,
    SPE610ExtOrgSelection,
    SPE620ExtOrgAccountAanvragen,
    SPE650BHExtOrgDetails,
    SPE696PatientEnquete,
    Metafields,
    SPE203Meldingen,
    multipage,
    Spe010Persoonsgegevens,
    VVNpersonHandelingen,
    SRPOOvereenkomsten,
    wizard
  },
  state: {
    filters: [],
    translation: {}, // translation
    todos: [],
    colors: {
      info: null,
      primary: null,
      success: null,
      danger: null,
      warning: null,
      light: null,
      lighter: null
    },
    menu: {
      menuItems: [],
      profgroupList: [],
      systemWarnings: [],
      languages: [],
      userInfo: {},
      profgroupListVisible: false,
      jumpmenuitems: [],
      statusMobileMenu: 0,
      isScrollonTop: true,
      menuOptions: {
        loadTopbanner: true,
        loadLangChoice: true,
        loadMenu: true,
        loadFixedLinks: true,
        disableMenu: false
      }
    },
    mediaQuery: {
      windowWidth: 0,
      windowHeight: 0,
      wXS: false,
      wSM: false,
      wMD: false,
      wLG: false,
      wXL: false
    },
    fixedContainerHeight: 0,
    loadingBar: {
      showwaiter: false,
      isloading: false,
      vueloadinglabel: false,
      vueloadedlabelanim: false,
      loadingMessage: '',
      loadedMessage: ''
    },
    notifications: [
      {
        groupname: 'info',
        messages: [],
        color: 'gritter-info',
        visible: false,
        timeout: null
      },
      {
        groupname: 'light',
        messages: [],
        color: 'gritter-info',
        visible: false,
        timeout: null
      },
      {
        groupname: 'primary',
        messages: [],
        color: 'gritter-primary',
        visible: false,
        timeout: null
      },
      {
        groupname: 'warning',
        messages: [],
        color: 'gritter-warning',
        visible: false,
        timeout: null
      },
      {
        groupname: 'danger',
        messages: [],
        color: 'gritter-danger',
        visible: false,
        timeout: null
      }
    ],
    validationMessages: {
      validationMessagesOpen: false
    },
    currentUser: {
      personid: null,
      taalid: null,
      defaulttaalid: null,
      orgid: null,
      bergrpid: null,
      rol: null,
      subroles: null
    }
  },
  getters: {
    menuOptions: state => state.menu.menuOptions,
    colors: state => state.colors,
    mediaQuery: state => state.mediaQuery,
    isScrollonTop: state => state.menu.isScrollonTop,
    translation: state => key => {
      return state.translation[key] ? state.translation[key] : ''
    },
    getFilters: state => {
      return state.filters
    },
    getFilter: (state, getters) => filternaam => {
      return state.filters.find(filt => filt.name === filternaam)
    },
    getLoading: state => {
      return state.loading
    },
    languages: state => {
      return state.menu.languages
    },
    menu: state => {
      return state.menu
    },
    menuitems: state => {
      return state.menu.menuItems.filter(i => i.tblMenuItemTypeID === 1 && i.tblMenuItemParentMenuItemID === null)
    },
    submenuitems: state => {
      return state.menu.menuItems.filter(i => i.tblMenuItemTypeID === 1 && i.tblMenuItemParentMenuItemID !== null)
    },
    fixedlinks: state => {
      return state.menu.menuItems.filter(i => i.tblMenuItemTypeID === 2)
    },
    userInfo: state => {
      return state.menu.userInfo
    },
    profgroupList: state => {
      return state.menu.profgroupList
    },
    profgroupListVisible: state => {
      return state.menu.profgroupListVisible
    },
    jumpmenuitems: state => {
      return state.menu.jumpmenuitems
    },
    statusMobileMenu: state => {
      return state.menu.statusMobileMenu
    },
    systemWarnings: state => {
      return state.menu.systemWarnings
    },
    fixedContainerHeight: state => state.fixedContainerHeight,
    loadingBar: state => state.loadingBar,
    notifications: state => state.notifications,
    hasFullscreenNotification: state => {
      let hasbightml = false
      state.notifications.forEach(g => {
        if (g.messages.filter(m => m.bightml).length !== 0) {
          hasbightml = true
        }
      })

      return hasbightml
    },
    getnotificationTitle: state => groupname => {
      if (groupname === 'info') {
        return state.translation[6365]
      }
      if (groupname === 'primary') {
        return state.translation[6365]
      }
      if (groupname === 'warning') {
        return state.translation[12399]
      }
      if (groupname === 'danger') {
        return state.translation[14590]
      }
    },
    getvalidationMessageStatus: state => {
      return state.validationMessages.validationMessagesOpen
    },
    getCurrentUser: state => {
      return state.currentUser
    }
  },
  mutations: {
    setvalidationMessageStatus(state, status) {
      state.validationMessages.validationMessagesOpen = status
    },
    removeNotificationgroup(state, groupname) {
      state.notifications.filter(g => g.groupname === groupname)[0].messages = []
    },
    removeNotification(state, { guid, timeout = 0 }) {
      state.notifications.forEach(group => {
        group.messages = group.messages.filter(n => n.guid !== guid)
        group.visible = group.messages.length !== 0
      })
    },
    addNotification(
      state,
      { groupname, message, sticky = false, title = '', guid = util.guid(), bightml = false, removegroup = false }
    ) {
      if (groupname === '' || groupname === undefined || groupname === null) {
        groupname = 'primary'
      }
      let notif = state.notifications.filter(n => n.groupname === groupname)[0]
      let currentmessage
      if (notif.messages.filter(m => m.message === message).length === 0) {
        if (removegroup) {
          state.notifications.filter(g => g.groupname === groupname)[0].messages = []
        }
        currentmessage = { message, title, sticky, guid, bightml, animactive: false }
        setTimeout(() => {
          currentmessage.animactive = true
        }, 50)
        notif.messages.push(currentmessage)
      } else {
        // message tekst is gelijk dus geen nieuwe aanmaken, wel de guid overnemen in de huidige notification
        currentmessage = notif.messages.filter(m => m.message === message)[0]
        currentmessage.guid = guid
      }
      notif.visible = true
      if (!sticky) {
        clearTimeout(notif.timeout)
      }
      // PE-18782 aanpassing gritter. In het scenario sticky + non sticky notification, verdween ook de sticky als de timer van non-sticky was verlopen.
      // controleren of er in notif.messages minimaal 1 message in staat die sticky is.
      let findsticky = false
      if (notif.messages.some(m => m.sticky === true)) {
        // kijk of er een sticky message tussen de notificaties van de groep staat.
        findsticky = true
      }
      // als er minimaal 1 message in notif.messages sticky is blijft de notificatie header staan
      if (findsticky === true) {
        clearTimeout(notif.timeout)
        notif.timeout = setTimeout(() => {
          notif.messages.forEach(m => {
            if (m.sticky === false) {
              m.animactive = false
            }
          })
          notif.messages = notif.messages.filter(b => b.animactive === true) // alleen de sticky messages bijven staan
        }, 6000)
      } else {
        notif.timeout = setTimeout(() => {
          notif.messages.forEach(m => {
            m.animactive = false
          })
          setTimeout(() => {
            notif.visible = false
            notif.messages = []
          }, 400)
        }, 6000)
      }
    },
    toggleNotifications(state, groupname) {
      let notif = state.notifications.filter(n => n.groupname === groupname)[0]
      notif.messages = []
      notif.visible = !notif.visible
    },
    mouseEnterNotifications(state, groupname) {
      // PE-18782 aanpassing gritter. bij mouseneter blijft de non-sticky notificatie staan.
      let notif = state.notifications.filter(n => n.groupname === groupname)[0]
      notif.visible = true
      clearTimeout(notif.timeout)
    },
    mouseLeaveNotifications(state, groupname) {
      // PE-18782 aanpassing gritter. bij mouseleave wordt de timer van de non-sticky notificatie gereset en verdwijnt deze (en eventueel blijven sticky notif staan)
      let notif = state.notifications.filter(n => n.groupname === groupname)[0]
      notif.visible = true
      clearTimeout(notif.timeout)
      let findsticky = false
      if (notif.messages.some(m => m.sticky === true)) {
        // kijk of er een sticky message tussen de notificaties van de groep staat.
        findsticky = true
      }
      if (findsticky === true) {
        notif.timeout = setTimeout(() => {
          notif.messages.forEach(m => {
            if (m.sticky === false) {
              m.animactive = false
            }
          })
          notif.messages = notif.messages.filter(b => b.animactive === true) // alleen de sticky messages bijven staan
        }, 6000)
      } else {
        notif.timeout = setTimeout(() => {
          notif.messages.forEach(m => {
            m.animactive = false
          })
          setTimeout(() => {
            notif.visible = false
            notif.messages = []
          }, 400)
        }, 6000)
      }
    },
    setValidations(state, errors) {
      let validations = state.notifications.filter(n => n.group === 'validations')[0]
      validations.messages = errors.map(e => {
        return { message: e.error, title: 'dit is een titel' }
      })
      console.log(
        errors.map(e => {
          return { message: e.error, title: 'dit is een titel' }
        })
      )
    },
    startLoading(state, { showmessage, disablepage, loadingMessage, loadedMessage }) {
      if (disablepage !== false) {
        setTimeout(() => {
          state.loadingBar.showwaiter = true
        }, 50)
      }
      state.loadingBar.isloading = true
      if (showmessage) {
        state.loadingBar.vueloadinglabel = true
        state.loadingBar.vueloadedlabelanim = true
        if (!loadingMessage) {
          loadingMessage = state.translation[14378]
        }
        if (!loadedMessage) {
          loadedMessage = state.translation[14379]
        }
        state.loadingBar.loadingMessage = loadingMessage
        state.loadingBar.loadedMessage = loadedMessage
      }
    },
    stopLoading(state) {
      state.loadingBar.showwaiter = false
      state.loadingBar.isloading = false

      if (state.loadingBar.vueloadinglabel === true) {
        state.loadingBar.vueloadinglabel = false
        state.loadingBar.vueloadedlabel = true
        setTimeout(() => {
          state.loadingBar.vueloadedlabel = false
          state.loadingBar.vueloadedlabelanim = false
        }, 1500)
      }
    },
    setFixedContainerHeight(state, fixedContainerHeight) {
      state.fixedContainerHeight = fixedContainerHeight
    },
    setMenuOptions(state, menuOptions) {
      state.menu.menuOptions = menuOptions
    },
    setMediaQuery(state, value) {
      state.mediaQuery = value
    },
    setScrollOnTop(state, value) {
      state.menu.isScrollonTop = value
    },
    addJumpmenuitem(state, { anchor, label, icon = ['far', 'link'] }) {
      state.menu.jumpmenuitems.push({
        anchor,
        label,
        icon
      })
    },
    setstatusMobileMenu(state, statusMobileMenu) {
      if (statusMobileMenu === 2) {
        $('body, html').css('overflow', '')
        state.menu.statusMobileMenu = 1
        state.menu.profgroupListVisible = false
      } else {
        $('body, html').css('overflow', 'hidden')
        state.menu.statusMobileMenu = 2
      }
    },
    hideSubmenu(state, id) {
      state.menu.menuItems.filter(i => {
        return i.tblMenuItemTypeID === 1 && i.tblMenuItemParentMenuItemID === null
      })[id].hideSub = true
    },
    showSubmenu(state, id) {
      state.menu.menuItems.filter(i => {
        return i.tblMenuItemTypeID === 1 && i.tblMenuItemParentMenuItemID === null
      })[id].hideSub = false
    },
    toggleSubmenu(state, id) {
      var hide = state.menu.menuItems.filter(i => {
        return i.tblMenuItemTypeID === 1 && i.tblMenuItemParentMenuItemID === null
      })[id].hideSub
      state.menu.menuItems.filter(i => {
        return i.tblMenuItemTypeID === 1 && i.tblMenuItemParentMenuItemID === null
      })[id].hideSub = !hide
      return true
    },
    toggleprofgroupListVisible(state) {
      state.menu.profgroupListVisible = !state.menu.profgroupListVisible
    },
    setFilter(state, newfilter) {
      let indexfilt
      var match = state.filters.find((filt, index) => {
        indexfilt = index
        return filt.name === newfilter.name
      })

      if (match) {
        Vue.set(state.filters, indexfilt, newfilter)
      } else {
        state.filters.push(newfilter)
      }
    },
    deleteFilter(state, filtername) {
      state.filters = state.filters.filter(filt => filt.name !== filtername)
    },
    settranslations(state, data) {
      for (var trans in data) {
        if (util.UgetCookie('TextCookie') === 'True') {
          Vue.set(state.translation, data[trans].key, data[trans].value + '(' + data[trans].key + ')')
        } else {
          Vue.set(state.translation, data[trans].key, data[trans].value)
        }
      }
    },
    setmenu(state, menuds) {
      state.menu.menuItems = menuds.data0
      state.menu.profgroupList = menuds.data1
      state.menu.systemWarnings = menuds.data2
      state.menu.languages = menuds.data3
      state.menu.userInfo = menuds.data4[0]

      // check of er een redirect gedaan moet worden i.v.m. niet ingevulde gegevens
      if (state.menu.userInfo.redirect !== undefined && state.menu.userInfo.redirect !== null) {

        // 2nd condition added in behalf of issue PE-22617
        if (window.location.href.indexOf(state.menu.userInfo.redirect) === -1 && document.referrer.indexOf('.aspx') === -1) {
          if (util.UgetCookie('userFillInfoRedirect') !== 'true') {
            util.UsetCookie('userFillInfoRedirect', 'true')
            window.location = state.menu.userInfo.redirect
          }
        }
      } else {
        util.UsetCookie('userFillInfoRedirect', 'false')
      }

      state.menu.menuItems
        .filter(i => i.tblMenuItemTypeID === 1 && i.tblMenuItemParentMenuItemID === null)
        .forEach(it => {
          Vue.set(it, 'hideSub', true)
        })

      // check op ongelezen berichten

      // const ShowReadMessage =
      //   Browserstore.session('messagesreadMessage') === null &&
      //   state.menu.userInfo.messagesUnread > 0

      // if (ShowReadMessage) {
      //   util.showVueMessage(
      //     `
      //       <a href="${state.menu.userInfo.mailurl}">${
      //       state.translation[14793]
      //     } ${state.menu.userInfo.messagesUnread} ${
      //       state.translation[14792]
      //     }</a>
      //     `,
      //     'gritter-primary',
      //     true
      //   )

      //   Browserstore.session('messagesreadMessage', true)
      // }

      var event = new Event('VueMenuLoaded')
      // trigger custom event zodat buiten vue (oude js duidelijk is waneer het menu geladen is)
      window.dispatchEvent(event)

      // PE-18025 Sticky melding als iemand met IE11 werkt
      const ua = window.navigator.userAgent // Check the userAgent property of the window.navigator object
      const msie = ua.indexOf('MSIE ') // IE 10 or older
      const trident = ua.indexOf('Trident/') // IE 11
      if (msie > 0 || trident > 0) {
        if (
          (state.menu.userInfo.currentProfGroupID !== null || state.menu.userInfo.rol === 'EDU') &&
          Browserstore.session('IEwarning') !== true
        ) {
          PEStore.commit('addNotification', {
            groupname: 'warning',
            message: state.translation[16093],
            sticky: true
          })
          Browserstore.session('IEwarning', true)
        }
      }
      for (let warning of state.menu.systemWarnings) {
        const sticky = warning.tblSystemWarningIsSticky === 1
        const showWarning =
          state.menu.userInfo.rol !== null &&
          (warning.tblSystemWarningFrequency === 2 ||
            Browserstore.session('WarningID' + warning.tblSystemWarningID) === null)

        if (showWarning) {
          if (warning.warningUrl !== '') {
            warning.messagetext = `<a href="${warning.warningUrl}">${warning.messagetext}</a>`
          }

          PEStore.commit('addNotification', {
            groupname: warning.warningBSColor,
            message: warning.messagetext,
            sticky
          })
          Browserstore.session('WarningID' + warning.tblSystemWarningID, true)
        }
      }
    },
    checkmail(state, cnt) {
      state.menu.userInfo.messagesUnread = cnt
    },
    setCurrentUser(state, jwtDecoded) {
      // Cookies uitlezen
      const personId = util.UgetCookie('pe_PersonID')
      const rol = util.UgetCookie('pe_UserInRole')
      const profGrp = util.UgetCookie('pe_activeProfGroup')
      const profOrg = util.UgetCookie('pe_activeProfOrg')
      const subroles = util.UgetCookie('pe_Subroles') ? util.UgetCookie('pe_Subroles').split(',') : []

      state.currentUser = {
        personid: personId, // nog vragen wat we hiermee doen, zit niet in nieuwe currentUser
        taalid: jwtDecoded.taalid,
        defaulttaalid: jwtDecoded.defaulttaalid,
        orgid: profOrg,
        bergrpid: profGrp,
        rol: rol,
        subroles: subroles,
        containsAnySubrollen(expectedSubrollen) {
          const matches = this.subroles.filter(s => expectedSubrollen.includes(s))
          return matches.length > 0
        }
      }
    }
  },
  actions: {
    Logout: ({ state, commit }) => {
      EventBus.$emit('updateloading', 1, false, true)

      commit('setstatusMobileMenu', state.menu.statusMobileMenu)
    },
    changeProfGroup: async ({ commit }, id) => {
      EventBus.$emit('updateloading', 1)
      var data = await util.getData('/peapp/webmethod/changeProfGroup/' + id)
      window.location = data.url
      Browserstore.session('IEwarning', false) // PE-18025 Sticky melding als iemand met IE11 werkt
    },
    changeLang: async ({ commit }, id) => {
      console.log('changeLang')
      EventBus.$emit('updateloading', 1)

      await util.getData('/peapp/webmethod/changeLanguage/' + id)

      if (window.location.search) {
        var queryString = window.location.search.replace('?', '')
        var queryParams = queryString.split('&')

        const result = queryParams.filter(param => !param.startsWith('taalID') && !param.startsWith('langID'))

        window.location = window.location.origin + window.location.pathname + '?' + result.join('&')

        return
      }

      window.location = window.location.href
      // location.reload(true) // deze weer uitgezet, leek de oplossing, maar in sommige gevallen toch nog een post, i.p.v. GET   IssueNR 11726
    },
    checkmail: async ({ commit, dispatch }) => {
      setTimeout(() => {
        util.getDataApi('allroles/PEapi_checkmailcount').then(data => {
          commit('checkmail', data.ds.data0[0].cntmessages)
        })
      }, 1000)
    },
    getInitData: async ({ commit, dispatch }) => {
      const { route } = router.resolve(window.location.pathname)
      const isLoggedIn = await util.isLoggedIn()

      // als :role in route aanwezig is dan checken of men is ongeloged
      // als : role undefined is dan heeft de route geen role parameter, zie ook mainroutes.js
      if (route.params.role !== undefined && !isLoggedIn) {
        window.location = '/logout.aspx'
      }

      if (isLoggedIn) {
        const jwtDecoded = jwtDecode(util.UgetCookie('kongapikey'))

        Sentry.configureScope(scope => scope.setUser(jwtDecoded))
        commit('setCurrentUser', jwtDecoded)
      }

      const menupar = {}
      if (!isLoggedIn) {
        let pid = Number.parseInt(route.params.profgroup, 10)

        if (isNaN(pid)) {
          pid = Number.parseInt(route.params.profgroupID, 10)
        }        

        if (isNaN(pid)) {
          pid = util.RequestInt('pid')
        }

        if (!isNaN(pid)) {
          menupar.SES_bergrpid = pid
        }

      }

      let menuapi
      menuapi = 'public/PEapi_MenuItems'
      if (!isLoggedIn) {
        Browserstore.session.clear()
      }
      // else {
      //  menuapi = 'allroles/PEapi_MenuItems'
      // }

      // ie11 textid warning 16093
      translations.push(16093)
      const [menudata, transdata] = await Promise.all([
        util.getDataApi(menuapi, menupar),
        util.getDataApi('public/PEapi_Gettranslations', {
          transids: translations
        })
      ])
      commit('settranslations', transdata.ds.data0)
      commit('setmenu', menudata.ds)

      if (PEGLOBALS.DotnetPage) {
        commit('stopLoading', null, { root: true })
      }
    },
    gettranslations: async ({ commit, state }, ids) => {
      // haal de al aanwezige ids uit de array
      let getids = []
      for (var i = 0; i < ids.length; i++) {
        if (state.translation[ids[i]] === undefined) {
          getids.push(ids[i])
        }
      }

      // haal alleen de nog niet opgehaalde vertalingen op
      if (getids.length > 0) {
        let data = await util.getDataApi(
          'public/PEapi_Gettranslations',
          {
            transids: getids
          },
          false,
          false,
          true
        )

        if (data.status === '200') {
          commit('settranslations', data.ds.data0)
        }
      }
    }
  }
})

// maak deze 2 mutaties global voor de gritter meldingen
PEGLOBALS.startLoading = ({ showmessage, disablepage }) => {
  PEStore.commit('startLoading', { showmessage: showmessage, disablepage: disablepage })
}
PEGLOBALS.stopLoading = () => {
  PEStore.commit('stopLoading')
}

export const store = PEStore

export default function() {
  return PEStore
}

$(document).ready(function() {
  const colormanager = `<div id="colormanager">
<div class="bckcol-info"></div>
<div class="bckcol-primary"></div>
<div class="bckcol-success"></div>
<div class="bckcol-danger"></div>
<div class="bckcol-warning"></div>            
<div class="bckcol-info-light"></div>
<div class="bckcol-info-lighter"></div>
</div>`
  $('body').append(colormanager)

  PEStore.state.colors.info = $('.bckcol-info').css('background-color')
  PEStore.state.colors.primary = $('.bckcol-primary').css('background-color')
  PEStore.state.colors.success = $('.bckcol-success').css('background-color')
  PEStore.state.colors.danger = $('.bckcol-danger').css('background-color')
  PEStore.state.colors.warning = $('.bckcol-warning').css('background-color')
  PEStore.state.colors.light = $('.bckcol-info-light').css('background-color')
  PEStore.state.colors.lighter = $('.bckcol-info-lighter').css('background-color')
})

// de volgende 4 global functies zijn er voor om meldingen te kunnen weergeven vanuit de oude js en .net
window.XShowMessage = function(message, classname, sticky, groep, title) {
  let groupname = classname.replace('gritter-', '')
  let guid = util.guid()
  PEStore.commit('addNotification', { groupname, message, sticky, title, guid })

  return guid
}
window.XHideMessage = function(guid) {
  PEStore.commit('removeNotification', { guid })
}
window.XHideMessageGroup = function(groupname) {
  PEStore.commit('removeNotificationgroup', groupname)
}
// var telgritter = 0
window.showhelptekst = function(text, ctrl, bightml) {
  window.helpteksttimeout = setTimeout(() => {
    let guid = util.guid()
    PEStore.commit('addNotification', { groupname: 'info', message: text, sticky: false, title: '', guid, bightml })
  }, 500)
}
window.hidehelptekst = function() {
  clearTimeout(window.helpteksttimeout)
  if (typeof event !== 'undefined') {
    // eslint-disable-next-line
    if (xhr && xhr.readystate !== 4) {
      // eslint-disable-next-line
      xhr.abort()
    }
    // PEStore.commit('removeNotification', { guid: gritid, timeout: 6000 })
  }
}
